import React, { useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import moment from 'moment';
import { getCandidatContact } from '../../../../services/ContactService';
import { useParams } from 'react-router-dom';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../../../utils/gridStyles';
import { DataGrid } from '../../../../components/SortableDataGrid/SortableDataGrid';

const CustomToolbar = makeGridToolbar('Candidats Associés');

const CandidatsAssocie = () => {
  const [candidatContact, setCandidatContact] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const { idContact } = useParams();

  React.useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      setCandidatContact([]);
      try {
        const res = await getCandidatContact(idContact, page + 1, 50);
        if (!active) return;
        setCandidatContact(res.data.CandidatContact || []);
        setRowCount(res.data.count || 0);
      } catch {
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [page, idContact]);

  const columns = [
    {
      field: 'dateSignature', headerName: 'INTÉGRATION', width: 130,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#64748b' }}>
          {p.value?.date ? moment(p.value.date).format('DD/MM/YYYY') : '—'}
        </Typography>
      ),
    },
    {
      field: 'nomCandidat', headerName: 'NOM', width: 160,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'nom_mission', headerName: 'MISSION', flex: 1, minWidth: 200,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'linkedin', headerName: 'LINKEDIN', width: 130,
      renderCell: (p) => p.value ? (
        <a href={p.value} target="_blank" rel="noreferrer"
          style={{ textDecoration: 'none', color: '#0a66c2', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value}
        </a>
      ) : <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>,
    },
  ];

  const rows = (candidatContact || []).map((c) => ({ ...c }));

  return (
    <Box sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: '44vh', minHeight: 300, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        loading={loading}
        paginationMode="server"
        rowCount={rowCount}
        paginationModel={{ page, pageSize: 50 }}
        onPaginationModelChange={(m) => setPage(m.page)}
        pageSizeOptions={[50]}
        disableRowSelectionOnClick
        showToolbar
        slots={{ toolbar: CustomToolbar }}
        slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
        localeText={gridLocaleText}
        sx={commonGridSx}
      />
    </Box>
  );
};

export default CandidatsAssocie;
